import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServerUrlService } from '../services/server-url.service';
@Component({
	selector: 'app-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
	dataAvailable: boolean = false
	painelAtivo: string = "false"
	constructor(
		private serverUrlService: ServerUrlService,
		private router: Router,
		private route: ActivatedRoute
	) {
		if (this.route.snapshot.params.auth === sessionStorage.getItem('settings-auth')) {
			this.dataAvailable = true
			this.route.data.subscribe(
				data => {
					data.params.forEach((element: { chave: string; valor: string; }) => {
						if (element.chave === "TOTEM_USEPANELS")
							this.painelAtivo = element.valor
					});
				}
			)
		} else {
			const client = this.serverUrlService.getName()
			const url = "settings"
			this.router.navigate([`${client}/totem/autenticacao/${url}`])
		}
	}

	ngOnInit(): void {

	}
}
